export const FETCH_DUTY_REQUIREMENTS_REQUEST = 'FETCH_DUTY_REQUIREMENTS_REQUEST';
export const FETCH_DUTY_REQUIREMENTS_SUCCESS = 'FETCH_DUTY_REQUIREMENTS_SUCCESS';
export const FETCH_DUTY_REQUIREMENTS_FAILURE = 'FETCH_DUTY_REQUIREMENTS_FAILURE';
export const DUTY_COMPLIANCE_UPDATED = 'DUTY_COMPLIANCE_UPDATED';

export const fetchDutyRequirements = (siteId: string) => ({
  type: FETCH_DUTY_REQUIREMENTS_REQUEST,
  payload: { siteId },
});

export type DutyComplianceUpdatedPayload = {
  siteId: string;
  affectedDates: string[];
  compliance: DayCompliance[];
  timestamp: string;
};

export type DayCompliance = {
  date: string;
  duties: DutyCompliance[];
};

export type DutyCompliance = {
  dutyId: string;
  dutyName: string;
  periods: PeriodCompliance[];
  totalRequired: number;
  totalCurrent: number;
  isMet: boolean;
};

export type PeriodCompliance = {
  timeRange: string;
  required: number;
  current: number;
  isMet: boolean;
};

export const dutyComplianceUpdated = (payload: DutyComplianceUpdatedPayload) => ({
  type: DUTY_COMPLIANCE_UPDATED,
  payload,
});